<template>
  <section class="login">

    <form id="loginForm" class="login-form" @submit.prevent="submit">

      <header class="login-form--header">
        <h2 class="login-form--header-title" v-t="ready ? 'success' : 'title'"></h2>
      </header>

      <template v-if="ready">
        <div class="login-form--inputs">
          <div class="login-input--container">
          <div class="login-form--buttons">
            <router-link tag="button" :to="{ path: '/auth/login' }" type="submit" name="btnlogin" id="formSubmit" class="login-form--button" tabindex="3" v-t="'login'" />
          </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="login-form--inputs">

          <div class="login-input--container">
            <label for="token" v-t="'token'"></label>

            <div class="login-input--fields">
              <input class="login-input--field" type="text" disabled :value="token" required>

              <div class="login-input--notices">
                <p class="login-input--error active" :key="message" v-text="message" v-for="message in form.error('token')"></p>
                <p class="login-input--error" v-if="! form.has('token')"></p>
              </div>
            </div>
          </div>

          <div class="login-form--inputs">

            <div class="login-input--container">
              <label for="loginEmailInput" v-t="'email'"></label>
              <input id="loginEmailInput" type="email" name="login" class="login-input--field" tabindex='1' v-model="form.email" required>

              <p class="login-input--error active" :key="message" v-text="message" v-for="message in form.error('email')"></p>
              <p class="login-input--error" v-if="! form.has('email')"></p>
            </div>

          </div>

          <div class="login-input--container">
            <label for="loginPassInput" v-t="('password.label')"></label>

            <div class="login-input--fields">
              <input id="loginPassInput" :type="passwordType" name="senha" class="login-input--field inputPasswordHidden" tabindex='2' v-model="form.password" required>
              <p id="showPassword" class="btn--show-password" @click.prevent="togglePasswordType" v-t="('password.type.' + passwordType)"></p>
            </div>

            <div class="login-input--notices">
              <p class="login-input--error active" :key="message" v-text="message" v-for="message in form.error('password')"></p>
              <p class="login-input--error" v-if="! form.has('password')"></p>
            </div>

          </div>

          <div class="login-input--container">
            <label for="loginPassInput" v-t="('password.confirmation_label')"></label>

            <div class="login-input--fields">
              <input id="loginPassInput" :type="passwordType" name="senha" class="login-input--field inputPasswordHidden" tabindex='2' v-model="form.password_confirmation" required>
              <p id="showPassword" class="btn--show-password" @click.prevent="togglePasswordType" v-t="('password.type.' + passwordType)"></p>
            </div>

            <div class="login-input--notices">
              <p class="login-input--error active" :key="message" v-text="message" v-for="message in form.error('confirmation')"></p>
              <p class="login-input--error" v-if="! form.has('confirmation')"></p>
            </div>

          </div>


        </div>

        <div class="login-form--buttons">
          <button type="submit" name="btnlogin" id="formSubmit" class="login-form--button" tabindex="3">
            <span v-if="form.busy" v-t="'busy'"></span>
            <span v-t="'action'" v-else></span>
          </button>
        </div>
      </template>

      <div class="login-form--links">
        <p class="login-form--text">
          {{ $t('call') }}

          <router-link class="login-form--link" :to="{ path: '/auth/register' }" v-t="'register'"></router-link>
        </p>
      </div>
    </form>
  </section>
</template>

<script>
  import Form from 'core/form';
  import Axios from 'core/axios';

  export default {
    props: {
      token: {
        type: String,
      },
    },

    data: () => ({
      form: Form.from([
        'token', 'email', 'password', 'password_confirmation',
      ]),
      ready: false,
      passwordType: 'password',
    }),

    methods: {
      togglePasswordType () {
        this.passwordType = this.passwordType == 'text' ? 'password' : 'text';
      },

      submit () {
        if (this.ready) {
          return;
        }

        this.form.token = this.token;

        Axios.post('auth/password/reset', this.form.run())
          .then(() => {
            this.ready = true;
          })
          .catch(err => this.form.update(err));
      },
    },
  };
</script>

<i18n>
  {
    "pt_BR": {
      "email": "Seu e-mail:",
      "title": "Insira sua nova senha e confirme ela",
      "busy": "Atualizando senha",
      "login": "Ir para página de Login",
      "action": "Mudar senha",
      "call": "Ainda não possuo cadastro.",
      "register": "Cadastre-se agora.",
      "success": "Senha recuperada com sucesso!",
      "token": "Token de recuperação de senha",
      "password": {
        "label": "Informe sua nova senha:",
        "type": {
          "text": "Mostrar",
          "password": "Esconder"
        },
        "confirmation_label": "Confirme sua senha nova:"
      }
    }
  }
</i18n>



// WEBPACK FOOTER //
// src/components/Auth/Password.vue